export default __webpack_public_path__ + "static/media/patient.33c21ec1.png";